import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import StockAction from "../component/stockAction";
import PageLoader from "../component/loader";
import {
  getDeliveryPercentList,
  getGoogleSheet,
  getSymbolList,
  myWatchList,
  watchlistItemDelete,
} from "../action/api-services";

import moment from "moment";
import DeliveryGraph from "../component/deliveryGraph";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ModalSymbolBuy from "../component/modalSymbolBuy";
import { useNavigate } from "react-router-dom";
import SectorPanchang from "../component/sectorPanchag";
import StockStrength from "../component/stockStrength";
import { setDeliveryDataReducer } from "../redux/slice/deliveryData";
import { calculateLeaderScore } from "../utils/constants";
import { isFarFromEMA20 } from "../utils/utilsFunctions";

const WatchListPage = () => {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [myWatchListData, setMyWatchListData] = useState([]);
  const [myWatchListDataList, setMyWatchListDataList] = useState([]);
  const [symbolData, setSymbolData] = useState([]);
  const [todayData, setTodayData] = useState([]);
  const [paramsMeta, setParamsMeta] = useState([]);
  const [deliveryDataList, setDeliveryDataList] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [series, setSeries] = useState('EQ');
  const openModal = () => setModalShow(true);
  const closeModal = () => setModalShow(false);

  const NSE_Past_date = useSelector((state) => state.pastDate.value);
  // const [startDate, setStartDate] = useState(NSE_Past_date[0]?.max_date);
  const [startDate, setStartDate] = useState(new Date());
  const userToken = useSelector((state) => state.userToken.value);
  const navigate = useNavigate();


  useEffect(() => {
  if (!userToken) {
    navigate(`/`);
    return;
  }

  const current_date = moment(startDate).format("DDMMYY");
  setLoader(true);
  Promise.all([
    myWatchList(userToken),
    getSymbolList(series, '', userToken),
    getGoogleSheet("", userToken),
    getDeliveryPercentList('', 'portflio', '', '', series, '', userToken)
  ])
    .then(([watchRes, symbolRes, sheetRes, delivery]) => {
      setMyWatchListData(watchRes?.data?.data || []);
      setSymbolData(symbolRes?.data?.data || []);
      setTodayData(sheetRes?.data?.data?.json_data || []);
      setDeliveryDataList(delivery.data.data);
      dispatch(setDeliveryDataReducer(delivery.data.data));
    })
    .catch((err) => {
      console.log("Error", err);
    })
    .finally(() => setLoader(false));

}, [userToken, startDate]);

 useEffect(() => {
    if (myWatchListData && symbolData && todayData) {

        // Count duplicate symbols once
        const symbolCountMap = myWatchListData.reduce((acc, item) => {
            acc[item.symbol] = (acc[item.symbol] || 0) + 1;
            return acc;
        }, {});

        const filteredData = myWatchListData.reduce(
            (acc, item) => {

                const match = symbolData?.find(
                    (s) => s.symbol === item.symbol
                );


                let deliverylist = Object.values(deliveryDataList);
                const dd = deliverylist.find(d => d.symbol === item.symbol);
                const td = todayData.find(t => t.TICKER === item.symbol);
                const scoreData = {
                      ...dd,
                      RSI: dd?.RSI || 0,
                      ADX: dd?.ADX || 0,
                      delivery_per: dd?.stock_data?.[0]?.delivery_per || 0,
                      prev_delivery_per: dd?.stock_data?.[1]?.delivery_per || 0,
                      ttl_trd_qty: dd?.stock_data?.[0]?.ttl_trd_qty || 0,
                      prev_volume: dd?.stock_data?.[1]?.ttl_trd_qty || 0,
                  };

                const data = {
                    ...item,
                    symbol_count: symbolCountMap[item.symbol] || 1,
                    details: match,
                    LTP: td,
                    deliveryData: dd,
                    todayScore: calculateLeaderScore(scoreData)
                };

                // Sector Rotation / Heat Map
                if (
                    item.method === 'Sector Rotation' ||
                    item.method === 'Heat Map'
                ) {
                    acc.hotmap.push(data);
                } else {
                    acc.general.push(data);
                }

                return acc;
            },
            {
                hotmap: [],
                general: []
            }
        );

        setMyWatchListDataList(filteredData);
    }
}, [myWatchListData, symbolData, todayData]);

  const addPortfolioHandler = (e, item, type, rowId) => {
    e.preventDefault();
    const strength_count = document
      .querySelector("#" + rowId)
      ?.querySelector(".strength_count")
      ?.textContent?.trim();
    openModal(true);
    const itemMeta = {
      id: item.id,
      symbol: item.symbol,
      watch_price: item.watchlist_price,
      method: type === "hotStar" ? "HotStar" : item.method,
      deliveryPer: item.deliveryPer,
      sl_price: item.sl_price,
      gtt_price: item.gtt_price,
      strengthCount: strength_count ? strength_count : "0/20",
    };
    setParamsMeta(itemMeta);
  };

  const removePortfolioHandler = (e, id) => {
    e.preventDefault();
    let params = {
      symbol_Id: id,
    };
    watchlistItemDelete(params, userToken)
      .then(function (response) {
        if (response.data.status === true) {
         
          const element = document.getElementById("item_row_id_" + id);
          if (element) {
            element.remove();
          }
           toast.success(response.data.message, {
                autoClose: 100
            });
        } else {
          toast.error(response.data.message);
        }
      })
      .catch(function (err) {
        console.log("Error", err);
      });
  };

  return (
    <React.Fragment>
      <div className="pageContainer">
        {loader === true ? (
          <PageLoader />
        ) : (
          <div className="pagewrap fullheight">
            <table className="increaseOI table-responsive">
              <thead>
                <tr key={`item_0`}>
                  <th style={{ width: "60px" }}>Date</th>
                  <th style={{ width: "120px" }}>Symbol [{myWatchListDataList?.general?.length}]</th>
                  <th style={{ width: "15px" }}></th>
                  <th style={{ width: "40px" }}></th>
                  <th style={{ width: "40px", textAlign: "left" }}>Score</th>
                  <th style={{ width: "45px", textAlign: "left" }}>Strength</th>
                  <th style={{ width: "120px", textAlign: "left" }}>Sector</th>
                  <th style={{ width: "50px", textAlign: "left" }}>Indices</th>
                  <th style={{ width: "90px", textAlign: "left" }}>Method</th>
                  <th style={{ width: "70px" }}>Watch Price</th>
                  <th style={{ width: "55px" }}>LTP</th>
                  <th style={{ width: "55px" }}>ADX</th>
                  <th style={{ width: "60px" }}>EMA Dist</th>
                  <th style={{ width: "55px" }}>SL</th>
                  <th style={{ width: "55px" }}>GTT</th>
                  <th style={{ width: "50px" }}>Chn</th>
                  <th style={{ width: "50px" }}>P/L</th>
                  <th style={{ width: "60px" }}>52 Down</th>
                  <th style={{ width: "55px" }}>SMA200</th>
                  <th style={{ width: "80px" }}>Volume</th>
                  <th style={{ width: "50px" }}>Del%</th>
                  <th style={{ width: "80px", textAlign: "left" }}>Events</th>
                  <th style={{ width: "60px", textAlign: "center" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {todayData &&
                  myWatchListDataList?.general?.map((obj, index) => {
                    const symbolName = obj.symbol;
                    let LTP_price =  obj.LTP.LTP !== "#N/A" ? obj.LTP.LTP : obj.watchlist_price;
                    let pl_per = (LTP_price - obj.watchlist_price) * 100 / obj.watchlist_price;
                    let ttl_trd_qty = obj.deliveryData?.stock_data?.[0]?.ttl_trd_qty ?? 0;
                    let delivery_per = obj.deliveryData?.stock_data?.[0]?.delivery_per ?? 0;
                    let emaDistance =  isFarFromEMA20(LTP_price, obj.deliveryData.EMA20).ema_distance;

                    return obj.details?.hotStar !== "1" ||
                      obj.method !== "Symbol" ? (
                      <tr
                        className={`tr_${obj.details?.id}`}
                        key={`item_row_id_${index + 1}`}
                        id={`item_row_id_${obj.id}`}

                        style={{background: pl_per > 5? "#e5ffef":''}}
                      >
                        <td style={{background: obj.symbol_count > 1? "#ffde7a":""}}>{moment(obj.create_date).format("DD/MM/YYYY")}</td>
                        <td
                          className="symbolName"
                        >
                          {symbolName}{" "}
                          {obj.details?.hotStar === "1" ? (
                            <span className="hotStar"></span>
                          ) : null}

                          {obj?.deliveryData?.current_star === "1" ? <span className="currStar"></span> : null}
                        </td>
                        <td>
                          <StockAction
                            symbol={symbolName}
                            delivery={false}
                            currentPrice={LTP_price}
                            deliveryPer={obj.prediction?.delivery_per}
                            hotStar={obj.details?.hotStar}
                            myFev={obj.details?.myFev}
                            eventName={obj.method}
                            rowId={`item_row_id_${obj.id}`}
                            score = {obj.todayScore}
                          />
                        </td>
                        <td>
                          <DeliveryGraph
                            symbol={symbolName}
                            todayLTP={obj.LTP}
                            date={moment(NSE_Past_date[0]?.max_date).format(
                              "YYYY-MM-DD"
                            )}
                          />
                        </td>
                        <td style={{background: obj.todayScore > obj.score? "#72d172":""}} title={obj.score}>{obj.todayScore}</td>
                        <StockStrength
                          id={`w_${index}`}
                          selectedDate={startDate}
                          symbol={symbolName}
                          todayLTP={obj.LTP}
                          details={obj.details}
                        />
                        <SectorPanchang
                          symbol={symbolName}
                          sector={obj.details?.group_sector}
                          todayData={todayData}
                          symbolData={symbolData}
                          tag = "td"
                          align = "right"
                          durationDays = ""
                        />
                        <td className="indices" style={{ textAlign: "left" }}>
                          {(() => {
                            const label = obj.details?.nifty50
                              ? "50"
                              : obj.details?.nifty100
                              ? "100"
                              : obj.details?.nifty200
                              ? "200"
                              : obj.details?.nifty500
                              ? "500"
                              : obj.details?.totalMarket
                              ? "TM"
                              : "";
                            const excludedSeries = ["ETF", "BOND", "MF"];
                            const showFev =
                              obj.details?.myFev &&
                              !excludedSeries.includes(obj.details?.series);
                            return (
                              label + (showFev ? `${label ? ", " : ""}Fev` : "")
                            );
                          })()}
                        </td>
                        <td style={{ textAlign: "left", lineHeight:1.2 }}>{obj.method}</td>
                        <td style={{ textAlign: "right" }}>
                          {obj.watchlist_price}
                        </td>
                        <td
                          title={
                            obj.LTP?.DATETIME && obj.LTP?.DATETIME !== "#N/A"
                              ? moment(obj.LTP?.DATETIME).format(
                                  "DD/MM/YY HH:mm"
                                )
                              : null
                          }
                          style={{
                            color:
                              LTP_price > obj?.watchlist_price ? "#1c8b16" : "#f00",
                          }}
                        >
                          {LTP_price}
                        </td>
                        <td>{obj.deliveryData.ADX}</td>
                        <td>{emaDistance}%</td>
                        <td>{obj.sl_price}</td>
                        <td>{obj.gtt_price}</td>
                        <td
                          style={{
                            color:
                              obj.LTP.CHANGEPER > 0 ? "#1c8b16" : "#f00",
                          }}
                        >
                          {obj.LTP.CHANGEPER.toFixed(2)}%
                        </td>
                        <td
                          style={{
                            color:
                              LTP_price > obj?.watchlist_price ? "#1c8b16" : "#f00",
                          }}
                        >
                          {(
                            ((LTP_price - obj.watchlist_price) * 100) / obj.watchlist_price).toFixed(2)}%
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {obj.details?.high52w
                            ? (
                                ((obj.details?.high52w - LTP_price) * 100) /
                                obj.details?.high52w
                              ).toFixed(2)
                            : ""}
                          %
                        </td>
                        <td
                          style={{
                            textAlign: "right",
                            background:
                              obj.deliveryData?.SMA50 > obj.deliveryData?.SMA200
                                ? "#e2ffe5"
                                : "#fff8f8",
                          }}
                          title={`SMA50: ${obj.deliveryData?.SMA50}`}
                        >
                          {obj.deliveryData?.SMA200}
                        </td>
                        <td style={{background:obj.LTP.VOLUME > ttl_trd_qty? "#72d172":""}} title={Number(ttl_trd_qty).toLocaleString("en-IN")}>{Number(obj.LTP.VOLUME).toLocaleString("en-IN")}</td>
                        <td>{delivery_per}%</td>
                        <td>{obj.details?.events}</td>
                        <td>
                          <button
                            type="button"
                            className="addPortfolio"
                            onClick={(e) =>
                              addPortfolioHandler(
                                e,
                                obj,
                                obj.method,
                                "item_row_id_" + obj.id
                              )
                            }
                          ></button>
                          <button
                            type="button"
                            className="removelist"
                            onClick={(e) => removePortfolioHandler(e, obj.id)}
                          ></button>
                        </td>
                      </tr>
                    ) : null;
                  })}
                <tr style={{ backgroundColor: "#f0f0f0" }}>
                  <td colSpan={23} style={{ paddingTop: myWatchListDataList?.general?.length > 0 ? "40px" : "8px" }}>
                    <h6>Week Hot Star [{myWatchListDataList?.hotmap?.length}]</h6>
                  </td>
                </tr>
                {todayData &&
                  myWatchListDataList?.hotmap?.map((obj, index) => {
                    const symbolName = obj.symbol;
                    let LTP_price =  obj.LTP.LTP !== "#N/A" ? obj.LTP.LTP : obj.watchlist_price;
                    let pl_per = (LTP_price - obj.watchlist_price) * 100 / obj.watchlist_price;
                    let ttl_trd_qty = obj.deliveryData?.stock_data?.[0]?.ttl_trd_qty ?? 0;
                    let delivery_per = obj.deliveryData?.stock_data?.[0]?.delivery_per ?? 0;
                    let emaDistance =  isFarFromEMA20(LTP_price, obj.deliveryData?.EMA20).ema_distance;

                    return obj.details?.hotStar !== "1" ||
                      obj.method !== "Symbol" ? (
                      <tr
                        className={`tr_${obj.details?.id}`}
                        key={`item_row_id_${index + 1}`}
                        id={`item_row_id_${obj.id}`}

                        style={{background: pl_per > 5? "#e5ffef":''}}
                      >
                        <td style={{background: obj.symbol_count > 1? "#ffde7a":""}}>{moment(obj.create_date).format("DD/MM/YYYY")}</td>
                        <td
                          className="symbolName"
                        >
                          {symbolName}{" "}
                          {obj.details?.hotStar === "1" ? (
                            <span className="hotStar"></span>
                          ) : null}

                          {obj?.deliveryData?.current_star === "1" ? <span className="currStar"></span> : null}
                        </td>
                        <td>
                          <StockAction
                            symbol={symbolName}
                            delivery={false}
                            currentPrice={LTP_price}
                            deliveryPer={obj.prediction?.delivery_per}
                            hotStar={obj.details?.hotStar}
                            myFev={obj.details?.myFev}
                            eventName={obj.method}
                            rowId={`item_row_id_${obj.id}`}
                            score = {obj.todayScore}
                          />
                        </td>
                        <td>
                          <DeliveryGraph
                            symbol={symbolName}
                            todayLTP={obj.LTP}
                            date={moment(NSE_Past_date[0]?.max_date).format(
                              "YYYY-MM-DD"
                            )}
                          />
                        </td>
                        <td style={{background: obj.todayScore > obj.score? "#72d172":""}} title={obj.score}>{obj.todayScore}</td>
                        <StockStrength
                          id={`w_${index}`}
                          selectedDate={startDate}
                          symbol={symbolName}
                          todayLTP={obj.LTP}
                          details={obj.details}
                        />
                        <SectorPanchang
                          symbol={symbolName}
                          sector={obj.details?.group_sector}
                          todayData={todayData}
                          symbolData={symbolData}
                          tag = "td"
                          align = "right"
                          durationDays = ""
                        />
                        <td className="indices" style={{ textAlign: "left" }}>
                          {(() => {
                            const label = obj.details?.nifty50
                              ? "50"
                              : obj.details?.nifty100
                              ? "100"
                              : obj.details?.nifty200
                              ? "200"
                              : obj.details?.nifty500
                              ? "500"
                              : obj.details?.totalMarket
                              ? "TM"
                              : "";
                            const excludedSeries = ["ETF", "BOND", "MF"];
                            const showFev =
                              obj.details?.myFev &&
                              !excludedSeries.includes(obj.details?.series);
                            return (
                              label + (showFev ? `${label ? ", " : ""}Fev` : "")
                            );
                          })()}
                        </td>
                        <td style={{ textAlign: "left", lineHeight:1.2 }}>{obj.method}</td>
                        <td style={{ textAlign: "right" }}>
                          {obj.watchlist_price}
                        </td>
                        <td
                          title={
                            obj.LTP?.DATETIME && obj.LTP?.DATETIME !== "#N/A"
                              ? moment(obj.LTP?.DATETIME).format(
                                  "DD/MM/YY HH:mm"
                                )
                              : null
                          }
                          style={{
                            color:
                              LTP_price > obj?.watchlist_price ? "#1c8b16" : "#f00",
                          }}
                        >
                          {LTP_price}
                        </td>
                        <td>{obj.deliveryData?.ADX}</td>
                        <td>{emaDistance}%</td>
                        <td>{obj.sl_price}</td>
                        <td>{obj.gtt_price}</td>
                        <td
                          style={{
                            color:
                              obj.LTP?.CHANGEPER > 0 ? "#1c8b16" : "#f00",
                          }}
                        >
                          {obj.LTP?.CHANGEPER}%
                        </td>
                        <td
                          style={{
                            color:
                              LTP_price > obj?.watchlist_price ? "#1c8b16" : "#f00",
                          }}
                        >
                          {(
                            ((LTP_price - obj.watchlist_price) * 100) / obj.watchlist_price).toFixed(2)}%
                        </td>
                        <td style={{ textAlign: "right" }}>
                          {obj.details?.high52w
                            ? (
                                ((obj.details?.high52w - LTP_price) * 100) /
                                obj.details?.high52w
                              ).toFixed(2)
                            : ""}
                          %
                        </td>
                        <td
                          style={{
                            textAlign: "right",
                            background:
                              obj.deliveryData?.SMA50 > obj.deliveryData?.SMA200
                                ? "#e2ffe5"
                                : "#fff8f8",
                          }}
                          title={`SMA50: ${obj.deliveryData?.SMA50}`}
                        >
                          {obj.deliveryData?.SMA200}
                        </td>
                        <td style={{background:obj.LTP.VOLUME > ttl_trd_qty? "#72d172":""}} title={Number(ttl_trd_qty).toLocaleString("en-IN")}>{Number(obj.LTP.VOLUME).toLocaleString("en-IN")}</td>
                        <td>{delivery_per}%</td>
                        <td>{obj.details?.events}</td>
                        <td>
                          <button
                            type="button"
                            className="addPortfolio"
                            onClick={(e) =>
                              addPortfolioHandler(
                                e,
                                obj,
                                obj.method,
                                "item_row_id_" + obj.id
                              )
                            }
                          ></button>
                          <button
                            type="button"
                            className="removelist"
                            onClick={(e) => removePortfolioHandler(e, obj.id)}
                          ></button>
                        </td>
                      </tr>
                    ) : null;
                  })}
              </tbody>
            </table>
          </div>
        )}
      </div>
      <ModalSymbolBuy
        show={modalShow}
        onHide={closeModal}
        paramsMeta={paramsMeta}
        newEntry={false}
      />
    </React.Fragment>
  );
};
export default WatchListPage;
